import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";

import { FilterConfigView } from "../filter-config.view";
@Component({
    selector: "filter-config-section",
    templateUrl: "./filter-config-section.view.html",
    providers: []
})
export class FilterConfigSectionView extends FilterConfigView {}
